import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { colors } from "../../theme/colors";
import { formatRatingTooltipDate } from "./profileRecentMatches";

export const TOOLTIP_DIVIDER_INSET = "0.85rem";

export const TOOLTIP_ROW_SX = {
    px: TOOLTIP_DIVIDER_INSET,
    pt: "0.85rem",
    pb: "0.575rem",
};

export function ProfileMatchTooltipDivider({ fullWidth = false }) {
    return (
        <Box
            sx={{
                height: "1px",
                bgcolor: colors.border.default,
                ...(fullWidth ? {} : { mx: TOOLTIP_DIVIDER_INSET }),
            }}
        />
    );
}

ProfileMatchTooltipDivider.propTypes = {
    fullWidth: PropTypes.bool,
};

export default function ProfileMatchTooltipHeader({
    timestamp,
    won,
    myScore,
    oppScore,
}) {
    const accent = won ? colors.state.success.main : colors.state.danger.main;

    return (
        <>
            <Box
                sx={{
                    px: TOOLTIP_DIVIDER_INSET,
                    py: "0.7rem",
                    background: alpha(colors.background.surface, 0.55),
                }}
            >
                <Typography
                sx={{
                    fontSize: "0.62rem",
                    fontWeight: 600,
                    letterSpacing: "0.08em",
                    textTransform: "uppercase",
                    color: colors.text.muted,
                    lineHeight: 1.3,
                    fontVariantNumeric: "tabular-nums",
                }}
            >
                {formatRatingTooltipDate(timestamp)}
            </Typography>

            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.55rem",
                    mt: "0.55rem",
                }}
            >
                <Box
                    sx={{
                        minWidth: "1.35rem",
                        height: "1.35rem",
                        borderRadius: "5px",
                        bgcolor: accent,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                    }}
                >
                    <Typography
                        sx={{
                            color: colors.text.primary,
                            fontSize: "0.68rem",
                            fontWeight: 700,
                            lineHeight: 1,
                        }}
                    >
                        {won ? "W" : "L"}
                    </Typography>
                </Box>

                <Typography
                    component="span"
                    sx={{
                        fontSize: "0.95rem",
                        fontWeight: 700,
                        letterSpacing: "0.04em",
                        fontVariantNumeric: "tabular-nums",
                        lineHeight: 1,
                    }}
                >
                    <Box component="span" sx={{ color: accent }}>
                        {myScore}
                    </Box>
                    <Box component="span" sx={{ color: colors.text.muted, mx: "0.2rem" }}>
                        :
                    </Box>
                    <Box component="span" sx={{ color: colors.text.secondary }}>
                        {oppScore}
                    </Box>
                </Typography>
            </Box>
            </Box>

            <ProfileMatchTooltipDivider fullWidth />
        </>
    );
}

ProfileMatchTooltipHeader.propTypes = {
    timestamp: PropTypes.number,
    won: PropTypes.bool,
    myScore: PropTypes.number,
    oppScore: PropTypes.number,
};
